/*--------------------------------------------------------------
>>> TABLE OF CONTENTS:
----------------------------------------------------------------
1.0 - Animation
--------------------------------------------------------------*/

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// 1.0 - Animation
export function elementAnimation() {
    const element = gsap.utils.toArray('.js-animate');

    element.forEach((item) => {
        gsap.set(item, {autoAlpha: 0, y: 50});
        const anim = gsap.fromTo(item, {autoAlpha: 0, y: 50}, {duration: .5, autoAlpha: 1, y: 0});
        ScrollTrigger.create({
            trigger: item,
            start: "top 85%",
            animation: anim,
            toggleActions: 'play none none none',
            once: true, 
            // markers: true
        });
    });
}